export default "__VITE_ASSET__DDOPJPQo__"